// ABOUTME: The idle "ride" motion (a slow bob and tilt) shared by the weather sprite and the 2A floating face and name.
// ABOUTME: Exposed as an sx fragment so each user gets the keyframes and the 5s loop together.

export const WR_RIDE_KEYFRAMES = {
  '@keyframes wrRide': {
    '0%, 100%': { transform: 'translateY(2px) rotate(-1.6deg)' },
    '50%': { transform: 'translateY(-3px) rotate(2deg)' },
  },
} as const;

export const WR_RIDE_ANIMATION = 'wrRide 5s ease-in-out infinite';
